(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Clases', Clases);

    Clases.$inject = ['$resource'];

    function Clases ($resource) {
    	var resourceUrl =  'apo/profesores:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep/:id/:idp';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'obtener': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
